import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import { EFKALoader } from '../EFKALogoLoader/EFKALoader.component';

export const MainLoadingView = () => {
  const { t } = useTranslationHelper('common');
  return (
    <div style={{ display: 'flex', gap: 10, paddingBlockStart: '10vh', alignItems: 'center', flexDirection: 'column' }}>
      <EFKALoader />
      <p style={{ fontWeight: 'bold' }}>{t('pleaseWait')}</p>
    </div>
  );
};
